import script from "./ImageRectOutline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageRectOutline.vue?vue&type=script&lang=ts&setup=true"

import "./ImageRectOutline.vue?vue&type=style&index=0&id=35e36256&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e36256"]])

export default __exports__